/* Polyfill for the stage-3 "Map upsert" proposal methods that pdfjs-dist v6
 * calls (Map.prototype.getOrInsertComputed / getOrInsert, and the WeakMap
 * equivalents). No stable browser ships these yet, so without this the PDF
 * engine throws "getOrInsertComputed is not a function" on every render —
 * on the main thread AND inside the PDF worker. This module is imported at
 * the top of both contexts (see utils/pdfjs.ts and utils/pdfWorkerEntry.ts).
 * It is a no-op once browsers ship the real methods.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
type Upsertable = { has(k: unknown): boolean; get(k: unknown): unknown; set(k: unknown, v: unknown): unknown };

for (const proto of [Map.prototype, WeakMap.prototype] as unknown as Array<Record<string, unknown>>) {
  if (typeof proto.getOrInsert !== "function") {
    Object.defineProperty(proto, "getOrInsert", {
      value(this: Upsertable, key: unknown, defaultValue: unknown) {
        if (!this.has(key)) this.set(key, defaultValue);
        return this.get(key);
      },
      writable: true,
      configurable: true,
    });
  }
  if (typeof proto.getOrInsertComputed !== "function") {
    Object.defineProperty(proto, "getOrInsertComputed", {
      value(this: Upsertable, key: unknown, callback: (key: unknown) => unknown) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
      },
      writable: true,
      configurable: true,
    });
  }
}

export {};
